exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-6298de76]{display:flex}", ""]);

// exports
